import { defineMessages } from 'react-intl';

export default defineMessages({
    pageTitle: {
        id: 'ri.policy.view.policy-details.Policy Details',
        defaultMessage: 'Policy Details: {policyNumber}'
    },
    currentTab: {
        id: 'ri.policy.view.policy-details.tab.Current',
        defaultMessage: 'Current'
    },
    changePolicy: {
        id: 'ri.policy.view.policy-details.Change Policy',
        defaultMessage: 'Change Policy'
    },
    renewalTab: {
        id: 'ri.policy.view.policy-details.tab.Renewing',
        defaultMessage: 'Renewing'
    },
    DownloadIDCard: {
        id: 'ri.policy.view.policy-details.Download ID Card',
        defaultMessage: 'Download ID Card'
    }
});
